import * as React from 'react';

import {SpinnerReact} from 'common/components/spinner';
import {SpinnerSize} from 'common/components/spinner/types';

import {SetupGuideContext, Step} from '../types';
import {Scrollable, ScrollableElement, scrollSpy, scrollToStep} from '../components/scroll-manager';
import {SideNav} from '../components';
import {Explore, Implement} from '../steps';
import {EventsV1} from '../steps/events/events-v1';
import styles from '../index.module.styl';

export const ModalContent = (props) => {
  const {modalManager, step} = React.useContext(SetupGuideContext);

  const initialized = React.useRef(false);
  React.useEffect(() => {
    if (initialized.current === false && step !== null) {
      scrollToStep(step, {skipAnimation: true});
      scrollSpy.update();
      initialized.current = true;
    }
  }, [step]);

  const {closeModal} = modalManager;

  const isActive = (stepId) => {
    const orderedStep = Object.values(Step);
    return orderedStep.indexOf(stepId) <= orderedStep.indexOf(step);
  };

  return (
    <div className={styles.layout}>
      <SideNav
        onClose={() => {
          closeModal();
        }}
      />
      <Scrollable className={styles.rhs}>
        {props.isLoading ? (
          <div className={styles.spinner}>
            <SpinnerReact size={SpinnerSize.Large} />
          </div>
        ) : (
          <>
            <ScrollableElement name={Step.Events} active={isActive(Step.Events)} viewSpy>
              <EventsV1 />
            </ScrollableElement>
            <ScrollableElement name={Step.Implement} active={isActive(Step.Implement)} viewSpy>
              <Implement />
            </ScrollableElement>
            <ScrollableElement name={Step.Explore} active={isActive(Step.Explore)} viewSpy>
              <Explore />
            </ScrollableElement>
          </>
        )}
      </Scrollable>
    </div>
  );
};
